(() => {
  angular
    .module('gm.common.filters')
    .filter('gmyFormatCurrency', gmyFormatCurrency);

  function gmyFormatCurrency(
    GmyCurrencies
  ) {
    'ngInject';

    const currencyHash = GmyCurrencies.getCurrencyHash();

    return (origInput, currencyCode, withSigns = true, withDecimal = true) => {
      let formatted;
      let currency;

      const input = parseFloat(origInput);
      if ((isNaN(input)) || (input === Infinity)) {
        return '';
      }

      const decimal = GmyCurrencies.getDecimals(currencyCode);

      if (GmyCurrencies.currencyExists(currencyCode)) {
        currency = currencyHash[currencyCode];
      } else {
        currency = {
          code: currencyCode,
          sign: currencyCode,
          post: '',
        };
      }

      const negative = input < 0;
      // format the currency
      const parts = Math.abs(input).toFixed(decimal).split('.');
      formatted = parts[0].split('')
        .reverse()
        .reduce((origRes, part, indx) => {
          const res = origRes + (indx > 0 && indx % 3 === 0 ? ',' : '');
          return res.concat(part);
        }, '')
        .split('')
        .reverse()
        .join('');

      // decimals
      if (withDecimal && decimal > 0) {
        formatted += parts[1] ? `.${parts[1]}` : '';
      }

      return (negative ? '-' : '') + (withSigns
        ? currency.sign + formatted + currency.post : formatted);
    };
  }
})();
